import React, { Component } from 'react';
import '../../App.css';

import Footer from '../reusables/footer'

import logo from '../../img/corpo.jpg'
import fruit from '../../img/fruit.png'
import fish from '../../img/fish.png'
import roses from '../../img/roses.png'

class Empresa extends Component {
  render() {
    return (
      <div className="Empresa">
        <div className="main-container-empresa">
          <div id="logo-empresa">
            <img src={logo} alt=""/>
          </div>
          <div id="info-empresa">
            <h1>Acerca de Nosotros</h1>
            <p>PIORICOST® forma parte de INDUSTRIAS EXPORTADORAS “LA MANÁ” C.A. cuyas oficinas corporativas están ubicadas en Quito. D.M, Ecuador. INDUSTRIAS EXPORTADORAS “LA MANÁ” C.A. Incursiona en el sector Agro-Exportador y Agro-Industrial, actividades que comprenden la producción y comercialización de productos agropecuarios, silvicultura y de pesca, como: Pitahaya, Banano, Cacao, Rosas, Camarones, Langostinos, Atún, Crustáceos, Moluscos y de productos frescos provenientes de la pesca, para su posterior industrialización, con la elaboración de productos procesados hacia los mercados más exigentes del mundo como : EEUU, Unión Europea, Rusia, China, Arabia Saudita, entre otros, por medio de sus marcas PIORICOST FRUIT®, PIORICOST FISH® Y PIORICOST ROSES®.</p>
            <div className="logos-container">
              <img src={fruit} alt=""/>
              <img src={fish} alt=""/>
              <img src={roses} alt=""/>
            </div>
            <h1>Misión</h1>
            <p>En INDUSTRIAS EXPORTADORAS “LA MANÁ” C.A. tenemos el firme compromiso de comercializar productos agrícolas, acuícolas y agroindustriales de la más alta calidad, teniendo en cuenta las necesidades de cada uno de nuestros clientes y adaptarnos a cada una de sus exigencias, estamos conscientes que nuestro objetivo es trabajar con eficiencia, para obtener los mejores resultados tanto con nuestros proveedores, trabajadores, partnership y sobre todo con nuestros clientes.</p>
            <h1>Visión</h1>
            <p>Convertirnos en una Corporación de renombre y con presencia mundial por medio de nuestras filiales alrededor del mundo. Estamos conscientes de la visión que tiene el resto del mundo con respecto a nuestro país, por lo cual INDUSTRIAS EXPORTADORAS “LA MANÁ” C.A. tiene como fin cambiar esa percepción del Ecuador, haciendo que nuestro país se convierta en un icono de innovación y desarrollo científico, esto lo realizaremos de la mano de las investigaciones científicas( Biotecnología Vegetal), y su constante apuesta a la innovación hasta convertirnos en un referente mundial en producción y comercialización de productos agrícolas, acuícolas y agroindustriales.</p>
          </div>
        </div>
        <Footer/>
      </div>
    );
  }
}

export default Empresa;


// WEBPACK FOOTER //
// ./src/components/empresa/index.js